import './TestAttachmentsViewEditComponent.scss'
import React, {useCallback, useEffect, useState} from 'react';
import {CommonService} from "../../../../shared/services";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import TestAttachmentsViewComponent from "./test-attachments-view/testAttachmentsViewComponent";
import TestAttachmentsEditComponent from "./test-attachments-edit/testAttachmentsEditComponent";
import {ImageConfig} from "../../../../constants";
import LottieFileGenarationComponent
    from "../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import StatusCardComponent from "../../../../shared/components/status-card/statusCardComponent";

interface TestAttachmentsViewEditComponentProps {
    testDetails: any;
    onModeChange:Function;
    canEdit: boolean;
}

const TestAttachmentsViewEditComponent = (props: TestAttachmentsViewEditComponentProps) => {

        const {testDetails,onModeChange,canEdit} = props;
        const [mode, setMode] = useState<"view" | "edit">("view");
        const [testAttachmentsList, setTestAttachmentsList] = useState<any>([]);
        const [isTestAttachmentsListLoading, setIsTestAttachmentsListLoading] = useState<boolean>(false);
        const [isTestOrderAttachmentsListLoaded, setIsTestOrderAttachmentsListLoaded] = useState<boolean>(false);
        const [isTestAttachmentsListLoadingFailed, setIsTestAttachmentsListLoadingFailed] = useState<boolean>(false);

        const handleTestAttachments = useCallback((updatedTestOrderAttachments: any) => {
            setTestAttachmentsList(updatedTestOrderAttachments);
            setMode("view");
        }, []);

        const handleTestAttachmentEditCancel = useCallback(() => {
            setMode("view");
        },[])

        const getTestAttachmentsList = useCallback(() => {
            setIsTestAttachmentsListLoading(true);
            setIsTestOrderAttachmentsListLoaded(false);
            setIsTestAttachmentsListLoadingFailed(false);
            const payload = {}
            CommonService._test.getTestAttachments(testDetails.id, payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.data) {
                        setTestAttachmentsList(response.data);
                    }
                    setIsTestAttachmentsListLoading(false);
                    setIsTestOrderAttachmentsListLoaded(true);
                    setIsTestAttachmentsListLoadingFailed(false);
                })
                .catch((error: any) => {
                    setIsTestAttachmentsListLoading(false);
                    setIsTestOrderAttachmentsListLoaded(false);
                    setIsTestAttachmentsListLoadingFailed(true);
                });
        }, [testDetails])


        useEffect(() => {
            if (testDetails.id) {
                getTestAttachmentsList();
            }
        }, [testDetails, getTestAttachmentsList]);

        useEffect(()=>{
            onModeChange(mode);
        },[mode,onModeChange])

        return (
            <div className="test-attachments-component details-tab-data-wrapper">

                {
                    isTestAttachmentsListLoading && <div className="details-screen-loading-icon">
                        <LottieFileGenarationComponent
                            loop={true}
                            autoplay={true}
                            animationData={ImageConfig.LoadingLottieFile}/>
                    </div>
                }
                {
                    isTestAttachmentsListLoadingFailed && <>
                            <StatusCardComponent title={"Failed to load attachments"}
                                                 />
                    </>
                }
                {
                    isTestOrderAttachmentsListLoaded && <>
                        {
                            mode === "view" && <TestAttachmentsViewComponent
                                testAttachments={testAttachmentsList}
                                canEdit={canEdit}
                                onEditModeOpen={() => {
                                    setMode("edit")
                                }}
                            />
                        }
                        {
                            mode === "edit" && <TestAttachmentsEditComponent
                                testID={testDetails.id}
                                testAttachments={testAttachmentsList}
                                onUpdateComplete={handleTestAttachments}
                                onEditCancel={handleTestAttachmentEditCancel}
                            />
                        }
                    </>
                }
            </div>
        )
    }


;

export default TestAttachmentsViewEditComponent;